import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {},
  content: {},
  contentPadded: {
    paddingTop: 20,
    paddingHorizontal: 20,
    paddingBottom: 12,
  },
});
